import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Agents from "@/pages/Agents";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/agents" element={<Agents />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </SmoothScroll>
      <Toaster theme="dark" position="bottom-center" toastOptions={{ style: { background: "#121212", border: "1px solid rgba(255,255,255,0.08)", color: "#FAFAF9" } }} />
    </BrowserRouter>
  );
}

export default App;
